import type { WorkOrderId } from 'cadenza/api-client/workorder-api';
import { observeForResult } from 'cadenza/api-client/workorder-api';
import type { GenericGeocodingProgressEvent } from 'cadenza/geocoding/dto/geocoding-progress-event';
import type { EnrichmentResultEvent } from 'cadenza/geocoding/geocoding-progress-dialog/geocoding-progress-dialog';
import type { GeocodingType } from 'cadenza/geocoding/model/geocoding-type';

export async function observeWithGeocodingProgressDialog<T extends GeocodingType>(
  workOrderId: WorkOrderId,
  geocodingType: T,
): Promise<EnrichmentResultEvent> {
  const { GeocodingProgressDialog } = await import('./geocoding-progress-dialog');
  const progressDialog = new GeocodingProgressDialog(geocodingType);
  const createdReportWorksheetId = progressDialog.connectAndShow();
  try {
    const result = await observeForResult<unknown, GenericGeocodingProgressEvent<T>, EnrichmentResultEvent>(
      workOrderId,
      'enrichment-result',
    ).progress((progressEvent) => {
      switch (progressEvent.step) {
        case 'self-service-step-geocoding':
        case 'self-service-step-geocoder-ip':
          progressDialog.onGeocodingUpdate(progressEvent);
          break;
        case 'self-service-step-geocoding-table-metadata':
        case 'self-service-step-geocoder-ip-table-metadata':
          progressDialog.onGeocodingStart(progressEvent);
          break;
      }
    });
    progressDialog.onGeocodingCompleted(result);
    return {
      ...result,
      createdReportWorksheetId: await createdReportWorksheetId,
    };
  } finally {
    progressDialog.close();
  }
}
